<template>
  <v-row no-gutters>
    <v-col cols="12">
      <app-ag-grid
        title="Quotations"
        :columnDefs="columnDefs"
        :rowData="quotations"
        :loading="loading"
        @refresh="fetchQuotations"
        @add="onAdd"
        :mobileCard="mobileCard"
        @row-dbl-click="
          (data) => $router.push({ path: `quotations/${data._id}/edit` })
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "QuotationsPage",
  components: {
    AppAgGrid,
  },

  data() {
    return {
      loading: false,
      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          width: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-quotation"
                data-id="${params.data._id}"
                title="View Quotation"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-quotation")) {
              this.$router.push({ path: `quotations/${params.data._id}/view` });
            }
          },
        },
        { headerName: "Quotation #", field: "quotationNumber", width: 130 },
        { headerName: "Customer", field: "customer.name", width: 170 },
        {
          headerName: "Amount",
          field: "totalAmount",
          valueFormatter: (p) => this.formatCurrency(p.value),
          width: 150,
        },
        {
          headerName: "Valid Until",
          field: "validUntil",
          valueFormatter: (p) => this.formatDate(p.value),
          width: 150,
        },
        {
          headerName: "Status",
          field: "status",
          width: 130,
          valueGetter: (p) => (p.data?.isExpired ? "EXPIRED" : p.data?.status),
        },
        {
          headerName: "Created",
          field: "createdAt",
          valueFormatter: (p) => this.formatDate(p.value),
          width: 150,
        },
      ],
    };
  },

  computed: {
    quotations() {
      return this.$store.state.quotations.list || [];
    },

    mobileCard() {
      const statusColors = {
        DRAFT: { background: "#f1f5f9", color: "#475569" },
        SENT: { background: "#e6f0fb", color: "#0a5a90" },
        ACCEPTED: { background: "#e6f7ec", color: "#15803d" },
        REJECTED: { background: "#fdecea", color: "#c62828" },
        EXPIRED: { background: "#fff7e6", color: "#b8720a" },
        CONVERTED: { background: "#f1eafb", color: "#7c3aed" },
      };

      return {
        title: (row) => `#${row.quotationNumber}`,
        subtitle: (row) => row.customer?.name || "-",
        badge: (row) => {
          const text = row.isExpired ? "EXPIRED" : row.status || "-";
          return {
            text,
            style: statusColors[text] || { background: "#f1f5f9", color: "#475569" },
          };
        },
        fields: (row) => [
          { label: "Amount", value: this.formatCurrency(row.totalAmount) },
          { label: "Valid Until", value: this.formatDate(row.validUntil) },
        ],
        actions: (row) => [
          {
            label: "View",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () => this.$router.push({ path: `quotations/${row._id}/view` }),
          },
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `quotations/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchQuotations();
  },

  methods: {
    async fetchQuotations() {
      this.loading = true;
      try {
        await this.$store.dispatch("quotations/getQuotations");
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "quotations/create" });
    },

    formatCurrency(value) {
      if (value == null) return "-";
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(value);
    },

    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
